import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from '../../styles/printFont/vfs_fonts2';
import helper from "actions/helper";

const Print = async (infoPrint) => {
    const { vfs } = pdfFonts.pdfMake;
    pdfMake.vfs = vfs;

    pdfMake.fonts = {
        Roboto: {
            normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
            bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
            italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
            bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
        },
    };

    const getBody = () => {
        const body = [[
            { text: "Раздел", fillColor: '#B6DCFA', bold: true },
            { text: "Описание", alignment: 'center', fillColor: '#B6DCFA', bold: true }
        ]];

        infoPrint.medDiaryHasMedSection.filter(it => it.value).forEach(it => {
            body.push([
                it.title,
                it.value
            ]);
        });

        return body;
    };

    const documentDefinition = {
        pageSize: 'A4',
        content: [
            {
                style: 'client',
                text: [
                    "Пациент: ",
                    { text: `${infoPrint.fio}`, bold: true, },
                ],
                margin: [0, 0, 0, 10]
            },
            {
                style: 'doctor',
                text: [
                    "Дата рождения: ",
                    { text: infoPrint.birthday ? helper.date.toStr(infoPrint.birthday, "DD.MM.YYYY") : "", bold: true },
                ],
                margin: [0, 0, 0, 10]
            },
            {
                style: 'doctor',
                text: [
                    "Врач: ",
                    { text: infoPrint.doctor, bold: true, },

                ],
                margin: [0, 0, 0, 10]
            },
            {
                style: 'doctor',
                text: [
                    "Дата приема: ",
                    { text: helper.date.toStr(infoPrint.beginDate, "DD.MM.YYYY"), bold: true, },

                ],
                margin: [0, 0, 0, 10]
            },
            {
                style: 'doctor',
                text: [
                    "Зубная формула: ",
                    { text: infoPrint.teeths, bold: true, },

                ],
                margin: [0, 0, 0, 10]
            },
            {
                style: 'header2',
                text: [{ text: "Дневник истории болезни", bold: true }]
            },
            {
                style: 'itogo',
                table: {
                    widths: [120, '*'],
                    body: getBody()
                }
            },
            {
                table: {
                    widths: ['*', '*'],
                    body: [
                        ["Подпись пациента ФИО _____________ ", "Подпись доктора _____________"]
                    ],

                },
                layout: 'noBorders',
                margin: [0, 0, 0, 10]
            },
            {
                style: 'doctor',
                text: [
                    "Сформировано: ",
                    helper.date.toStr(new Date(), "DD.MM.YYYY")
                ],
                margin: [0, 0, 0, 10]
            },

        ],
        styles: {
            header: {
                fontSize: 9,
                lineHeight: 0.7,
                margin: [0, 10, 0, 20]
            },
            header2: {
                fontSize: 12,
                alignment: 'center',
                margin: [0, 0, 0, 15]
            },
            client: {
            },
            doctor: {
                margin: [0, 0, 0, 15]
            },
            table: {
                fontSize: 9,
            },
            itogo: {
                fontSize: 10,
                margin: [0, 15, 0, 15]
            },
            itogoTable: {
            },
            itogoTable2: {
            },
            signTable: {
                margin: [0, 20, 0, 0]
            },
        },
        defaultStyle: {
            fontSize: 10,
        }
    };

    pdfMake.createPdf(documentDefinition).open();

};

export default Print;
